import { HttpHeaders,HttpClient } from '@angular/common/http';

export const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'token': ''
    })
};
